<template>
    <wizard
        :steps="steps"
        :current-step="editSubmissionStep"
        :loading="loading"
    >
        <template #prepend>
            <risk-header :risk="riskHeader"/>
        </template>

        <x-form ref="productForm" class="wizard-step-form" @submit.prevent="submit">
            <x-container v-if="editSubmissionStep === 1">
                <editable-generic-questions
                    v-model="submission"
                    :currencies="currencies"
                    :clientAssignments="filteredClientAssignments"
                    isPlacingBrokerUserForEdit
                />

                <x-layout class="action-set" align-center>
                    <x-flex xs6 offset-xs3 class="action-set-actions">
                        <x-container>
                            <x-layout>
                                <x-flex xs6>
                                    <x-btn
                                        color="tertiary"
                                        @click="goToFirmOrder()"
                                    >
                                        <i class="material-icons mr-2">arrow_back</i>

                                        Cancel
                                    </x-btn>
                                </x-flex>

                                <x-flex xs6 text-xs-right>
                                    <x-btn
                                        class="wide"
                                        color="primary"
                                        @click="nextStep"
                                    >
                                        Next

                                        <i class="material-icons ml-2">trending_flat</i>
                                    </x-btn>
                                </x-flex>
                            </x-layout>
                        </x-container>
                    </x-flex>
                </x-layout>
            </x-container>

            <x-container v-if="editSubmissionStep === 2">
                <product-questions
                    v-model="submission"
                    :currencyCode="currencyCode"
                >
                    <template v-slot:submit-row>
                        <x-layout class="action-set" align-center>
                            <x-flex xs6 offset-xs3 class="action-set-actions">
                                <x-container>
                                    <x-layout>
                                        <x-flex xs6>
                                            <x-btn
                                                color="tertiary"
                                                @click="editSubmissionStep = 1"
                                            >
                                                <i class="material-icons mr-2">arrow_back</i>

                                                Back
                                            </x-btn>
                                        </x-flex>

                                        <x-flex xs6 text-xs-right>
                                            <x-btn
                                                class="wide"
                                                color="primary"
                                                @click="nextStep"
                                            >
                                                Next

                                                <i class="material-icons ml-2">trending_flat</i>
                                            </x-btn>
                                        </x-flex>
                                    </x-layout>
                                </x-container>
                            </x-flex>
                        </x-layout>
                    </template>
                </product-questions>
            </x-container>

            <x-container v-if="editSubmissionStep === 3">
                <x-layout class="question-set">
                    <x-flex xs2 offset-xs1>
                        <h3 class="question-set-title">Additional Information <span v-if="!this.submission.product_data.prior_experience" class="question-set-subtitle">(optional)</span></h3>
                    </x-flex>

                    <x-flex xs6 class="question-set-questions">
                        <additional-information-edit
                            v-model="submission.information_sections"
                            :insurer-list="insurerList"
                        />
                    </x-flex>
                </x-layout>

                <x-layout class="action-set" align-center>
                    <x-flex xs6 offset-xs3 class="action-set-actions">
                        <x-container>
                            <x-layout>
                                <x-flex xs6>
                                    <x-btn
                                        color="tertiary"
                                        @click="editSubmissionStep = 2"
                                    >
                                        <i class="material-icons mr-2">arrow_back</i>

                                        Back
                                    </x-btn>
                                </x-flex>

                                <x-flex xs6 text-xs-right>
                                    <x-btn
                                        class="wide"
                                        color="primary"
                                        type="submit"
                                        :disabled="!hasChanged"
                                    >
                                        Save changes

                                        <i class="material-icons ml-2">trending_flat</i>
                                    </x-btn>
                                </x-flex>
                            </x-layout>
                        </x-container>
                    </x-flex>
                </x-layout>
            </x-container>
        </x-form>

        <modal
            ref="confirmEdit"
            title="Confirm edit"
            confirmation
        >
            <div class="text-xs-left">
                <p>
                    You are editing an in the market submission, this will update the submission.
                </p>
                <p>
                    Are you sure?
                </p>
            </div>
        </modal>
    </wizard>
</template>

<script>
    import Wizard from '../../components/Broker/UIComponents/Wizard.vue';
    import RiskHeader from '~/components/Shared/Partials/RiskHeader';
    import StatusChip from "~/components/Shared/UIComponents/StatusChip";
    import ProgressLinearBar from "~/components/Broker/UIComponents/ProgressLinearBar";
    import ProductQuestions from '~/components/Broker/Products/ProductQuestions';
    import AdditionalInformationEdit from '~/components/Broker/UIComponents/AdditionalInformationEdit';
    import Modal from '~/components/Shared/UIComponents/Modal';
    import EditableGenericQuestions from '~/components/Broker/SubmissionWizard/EditableGenericQuestions.vue';
    import rules from '~/mixins/rules';

    export default {
        name: "BrokerFirmOrder",
        components: {
            Wizard,
            RiskHeader,
            ProgressLinearBar,
            StatusChip,
            ProductQuestions,
            AdditionalInformationEdit,
            Modal,
            EditableGenericQuestions
        },
        mixins: [rules],
        data() {
            return {
                loading: true,
                steps: [
                    'Build Product',
                    'Details',
                    'Additional Information'
                ],
                submission: {},
                editSubmissionStep: 1,
                hasChanged: false,
                facilities: [],
                currencies: [],
                editFirmOrder: false,
                clientAssignments: [],
            }
        },
        created() {
            this.fetchData();

            this.$eventBus.$on('submissionChanged', async () => {
                this.submission = (await axios.get(this.$root.api(`broker/submission/${this.$route.params.id}`))).data.data;
            });
        },
        methods: {
            async fetchData() {
                this.submission = (await axios.get(this.$root.api(`broker/submission/${this.$route.params.id}`))).data.data;
                this.facilities = (await axios.get(this.$root.api(`facility`))).data.data;
                this.currencies = (await axios.get(this.$root.api(`currency`))).data.data;
                this.clientAssignments = (await axios.get(this.$root.api('broker/client-assignment/placing-brokers'))).data;
                this.hasChanged = false;
                this.loading = false;
            },
            goToFirmOrder() {
                this.$router.push({path: `/agent/risk/${this.$route.params.id}`});
            },
            nextStep() {
                if (this.$refs.productForm.validate()) {
                    this.editSubmissionStep++;
                }
            },
            async submit() {
                if (this.$refs.productForm.validate()) {
                    if (await this.$refs.confirmEdit.open() === false) {
                        return;
                    }

                    this.loading = true;
                    this.load = false;
                    await axios.put(`/api/broker/submission/${this.$route.params.id}/edit`, this.submission);
                    this.$router.push({path: `/agent/risk/${this.$route.params.id}`});
                }
            },
        },
        watch: {
            "submission": {
                'handler': function (value) {
                    this.hasChanged = true;
                },
                deep: true
            },
        },
        computed: {
            insurerList() {
                return this.submission.offers.map(offer => offer.insurer);
            },
            riskHeader() {
                return {
                    id: this.submission.id,
                    client_company_name: this.submission.client_company.name,
                    obligor_name: this.submission.obligor_name,
                    country_name: this.submission.country_id ? this.submission.country.name : '',
                    status: this.submission.status
                };
            },
            currencyCode() {
                const selectedCurrency = this.currencies.find(currency => this.submission.currency_id === currency.id) || {};
                return selectedCurrency.code || '';
            },
            filteredClientAssignments() {
                return this.clientAssignments.filter(broker => broker.client_company.id === this.submission.client_company_id);
            }
        },
    }
</script>

<style lang="scss" scoped>
</style>
